import styled from "styled-components";

// export const Col = styled.div``
export const Container = styled.div`
  min-height: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;

  @media (min-width: 1100px) {
    max-width: 90%;
    margin: auto;
  }
  @media (min-width: 789px) {
    padding: 3em 5%;
  }
`;
export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20em, 1fr));
  grid-auto-rows: 35em;
  grid-gap: 1em 2em;
  height: 100%;

  @media (min-width: 200px) and (max-width: 1026px){
    grid-template-columns: repeat(auto-fit,minmax(15em,1fr));
    grid-auto-rows: 35em;
  }

  @media(min-width: 1100px){
    grid-template-columns: repeat(auto-fit, minmax(30em, 1fr));
    grid-auto-rows: 18em;
  }
`;
export const Col = styled.div`
  width: 100%;
  margin-bottom: 2em;
  border-radius: 15px;
  background: ${({ themed }) => (themed ? "#0F0E37" : "#ffffff")};
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover h2 {
    color: #de5240;
  }

  @media (min-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
    flex-direction: row;
  }
  /* @media (min-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  } */
`;
export const Image = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.3em;
  color: ${(props) => (props.color ? props.color : "")};
`;
export const H2 = styled.h2`
  margin: 0;
  margin-bottom: 0.5em;
  font-size: 1.5em;
  transition: all 0.5s ease;
`;
export const P = styled.p`
  margin: 0;
  margin-bottom: 1.5em;
  font-size: 1em;
`;
export const Span = styled.p`
  margin: 0;
  padding-top: 1em;
  font-size: 1.2em;
  color: #de5240;
`;
export const Date = styled.p`
  display: flex;
  align-items: center;
  align-self: flex-start;

  span {
    font-size: 1.5em;
  }
`;
